export default "__VITE_ASSET__CJRHEWlh__"